import type { OperatorDef } from "./types";

// ---------------------------------------------------------------------------
// Scalar operators
// ---------------------------------------------------------------------------

export const eq = (label = "Equals"): OperatorDef => ({
  value: "eq",
  label,
  input: "single",
});

export const ne = (label = "Not equals"): OperatorDef => ({
  value: "ne",
  label,
  input: "single",
});

export const contains = (label = "Contains"): OperatorDef => ({
  value: "contains",
  label,
  input: "single",
});

export const startsWith = (label = "Starts with"): OperatorDef => ({
  value: "startsWith",
  label,
  input: "single",
});

export const endsWith = (label = "Ends with"): OperatorDef => ({
  value: "endsWith",
  label,
  input: "single",
});

export const isIn = (label = "Is one of"): OperatorDef => ({
  value: "in",
  label,
  input: "multiple",
});

export const nin = (label = "Is not one of"): OperatorDef => ({
  value: "nin",
  label,
  input: "multiple",
});

export const gt = (label = "Greater than"): OperatorDef => ({
  value: "gt",
  label,
  input: "single",
});

export const gte = (label = "On or after"): OperatorDef => ({
  value: "gte",
  label,
  input: "single",
});

export const lt = (label = "Less than"): OperatorDef => ({
  value: "lt",
  label,
  input: "single",
});

export const lte = (label = "On or before"): OperatorDef => ({
  value: "lte",
  label,
  input: "single",
});

// ---------------------------------------------------------------------------
// Null / existence operators
// ---------------------------------------------------------------------------

export const isNull = (label = "Is empty"): OperatorDef => ({
  value: "isNull",
  label,
  input: "none",
});

export const isNotNull = (label = "Is not empty"): OperatorDef => ({
  value: "isNotNull",
  label,
  input: "none",
});

// ---------------------------------------------------------------------------
// Array field operators
// ---------------------------------------------------------------------------

export const has = (label = "Includes"): OperatorDef => ({
  value: "has",
  label,
  input: "single",
});

export const hasSome = (label = "Includes any of"): OperatorDef => ({
  value: "hasSome",
  label,
  input: "multiple",
});

export const hasEvery = (label = "Includes all of"): OperatorDef => ({
  value: "hasEvery",
  label,
  input: "multiple",
});

export const isEmpty = (label = "Is empty"): OperatorDef => ({
  value: "isEmpty",
  label,
  input: "none",
});

export const isNotEmpty = (label = "Is not empty"): OperatorDef => ({
  value: "isNotEmpty",
  label,
  input: "none",
});

// ---------------------------------------------------------------------------
// Common operator sets
// ---------------------------------------------------------------------------

export const STRING_OPERATORS: OperatorDef[] = [
  contains("Contains"),
  eq("Equals"),
  ne("Not equals"),
  startsWith("Starts with"),
  endsWith("Ends with"),
  isNull("Is empty"),
  isNotNull("Is not empty"),
];

export const ID_OPERATORS: OperatorDef[] = [
  eq("Is"),
  ne("Is not"),
  isNull("Is empty"),
  isNotNull("Is not empty"),
];

export const ID_ARRAY_OPERATORS: OperatorDef[] = [
  hasSome("Includes any of"),
  hasEvery("Includes all of"),
  isEmpty("Is empty"),
  isNotEmpty("Is not empty"),
];

export const DATE_OPERATORS: OperatorDef[] = [
  gte("On or after"),
  lte("On or before"),
  gt("After"),
  lt("Before"),
  isNull("Is empty"),
  isNotNull("Is not empty"),
];

export const NUMBER_OPERATORS: OperatorDef[] = [
  eq("Equals"),
  ne("Not equals"),
  gt("Greater than"),
  gte("Greater than or equal"),
  lt("Less than"),
  lte("Less than or equal"),
  isNull("Is empty"),
  isNotNull("Is not empty"),
];

export const BOOLEAN_OPERATORS: OperatorDef[] = [eq("Is")];
